import BaseService from '_services/rest/base';

class SettingsService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/settings`;
  }

  getUrlSave(id, url = '') {
    if (id) {
      return {
        url: `${this.getUrl()}${url}/${id}`,
        method: 'PUT',
      };
    }
    return {
      url: `${this.getUrl()}${url}`,
      method: 'POST',
    };
  }

  getCompanies() {
    return this.request(`${this.getUrl()}/company`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getClasses() {
    return this.request(`${this.getUrl()}/quotation-class/all`)
      .catch(err => {
        throw err;
      });
  }

  getSettings() {
    return this.request(`${this.getUrl()}/all`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getQuotationContractualItems(type) {
    return this.request(`${this.getUrl()}/contract-items?type=${type}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  removeQuotationContractualItems(id) {
    return this.request(`${this.getUrl()}/contract-items/${id}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  prepareOptions(settings, type = 'company') {
    const options = [];
    Object.keys(settings).map(key => (
      options.push({
        option: `${type}_${key}`,
        value: settings[key] || '',
      })
    ));
    return { ...options };
  }

  upload(file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.request(`${super.getUrl()}api/file`, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveOptions(settings, type) {
    const options = this.prepareOptions(settings, type);
    return this.request(`${this.getUrl()}`, { options }, 'PUT')
      .catch(err => {
        throw err;
      });
  }

  saveQuotationContractualItems(obligations, type) {
    const obligation = { ...obligations, type };
    const meta = this.getUrlSave(obligation.id, '/contract-items');
    return this.request(meta.url, obligation, meta.method)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveClass(classe) {
    const meta = this.getUrlSave(classe.id, '/quotation-class');
    let formData = new FormData();
    formData = this.setFormData(classe, formData);
    return this.request(meta.url, formData, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  removeClass(id) {
    return this.request(`${this.getUrl()}/quotation-class/${id}`, null, 'DELETE')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new SettingsService();
